import * as joi from 'joi';

export const peripheralDataSchema = joi.object().keys({
    subAddress: joi.number().required(),
    controllerMAC: joi.string().required(),
    locationId: joi.number().required(),
});
